import React, { createContext, FC, useEffect, useState } from 'react';

interface WindowFocusDetectorProviderProps {
  focused: boolean;
}

export const WindowFocusDetectorContext = createContext<WindowFocusDetectorProviderProps>({
  focused: true,
});

export const WindowFocusDetectorProvider: FC<WindowFocusDetectorProviderProps> = ({ children }) => {
  const [focused, setFocused] = useState(true);

  useEffect(() => {
    const handleFocus = () => setFocused(true);

    const handleBlur = () => setFocused(false);

    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  return (
    <WindowFocusDetectorContext.Provider value={{ focused }}>
      {children}
    </WindowFocusDetectorContext.Provider>
  );
};
